module.exports = __webpack_public_path__ + "static/media/blank_copy-may_28.32719bdd.pdf";